export default {
  ja:[
    "おっと！",
    "まだ通知がなにも来てないみたいだね！またあとでチェックしてみよう！",
  ],
  en: [
    "Oops!",
    "We still have nothing here for you! Come check again later!",
  ]
}
